import styled from "styled-components";

export const RecentlyGames = styled.div`
  background-color: whitesmoke;
  line-height: 30px;
  padding-right: 10px;
  font-weight: 600;
  font-size: 17px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  @media (max-width: 820px) {
    margin-bottom: 5px;
  }
`;

export const LoadMore = styled.div`
  background-color: #1517ac;
  line-height: 30px;
  width: max-content;
  letter-spacing: normal;
  font-size: 17.5px;
  font-stretch: normal;
  font-style: normal;
  padding: 0 20px;
  height: 30px;
  margin: 15px auto;
  text-align: center;
  border-radius: 999px;
  color: white;
  cursor: pointer;
`;

export const Container = styled.div`
  margin: 25px 0;
`;
